import VerticalTabList from './VerticalTabList';
import { VerticalTabListProps, VerticalTabListValueProps } from './types';

export type { VerticalTabListProps, VerticalTabListValueProps };
export default VerticalTabList;
